import { Box, Stack } from '@mui/material';
import styled, { css } from 'styled-components';

import Typography from 'components/elements/Typography';
import { DEFAULT_FONT } from 'commons/styles/font';

export const Container = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
  font-family: ${DEFAULT_FONT};
  font-size: 14px;
  color: black;
`;

export const LeftColumn = styled(Box)<{ $isBold?: boolean; $listOrder?: boolean }>`
  flex-basis: 50%;
  font-weight: ${({ $isBold }) => $isBold && '600'};

  ${({ $listOrder }) =>
    $listOrder &&
    css`
      min-width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const RightColumn = styled(Box)<{ $isBold?: boolean; $listOrder?: boolean }>`
  font-weight: ${({ $isBold }) => $isBold && '600'};
  flex-basis: 50%;
  text-align: left;

  ${({ $listOrder }) =>
    $listOrder &&
    css`
      min-width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const Row = styled(Box)<{
  $color?: string;
  $width?: string;
  $height?: string;
  $margin?: string;
  $maxWidth?: string;
}>`
  color: ${({ $color }) => $color};
  display: flex;
  justify-content: space-between;
  width: ${({ $width }) => $width || '100%'};
  max-width: ${({ $maxWidth }) => $maxWidth || '300px'};
  height: ${({ $height }) => $height};
  min-height: 25px;
  margin-bottom: 5px;
  margin: ${({ $margin }) => $margin};
`;

export const OrderList = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  max-width: 550px;
  margin-top: 1.25rem;
`;

export const AddendumValue = styled(Typography)`
  width: 100%;
  font-size: 14px !important;
  span {
    text-decoration: line-through;
  }
`;

export const ScrollContainer = styled(Stack)`
  width: 100%;
`;
